import { Component, Input, Output, EventEmitter, forwardRef } from "@angular/core"
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'

const noop = () => {}

@Component({
  selector: "number-select",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberSelectComponent),
      multi: true
    }
  ],
  styles: [require('./number-select.component.css')],
  template: `
  <ul class="pagination number-select">
    <li class="page-item number-select-item" *ngFor="let value of values" [ngClass]="{
      'active': valueIsSelected(value)
    }">
      <a class="page-link" href="#" (click)="selectValue($event, value)">{{ value }}</a>
    </li>
  </ul>
  `
})
export class NumberSelectComponent implements ControlValueAccessor {
  @Input() minValue: number = 0
  @Input() maxValue: number
  @Input('value')

  values: number[]
  private _value: number 

  @Output('change') private onChangeEmitter = new EventEmitter<Object>()

  ngOnInit() {
    this.values = Array(this.maxValue - this.minValue + 1).fill(null).map((_, i) => this.minValue + i)
  }

  selectValue(e: Event, value: number) {
    e.preventDefault()
    this.value = value
    this.onChangeEmitter.emit({ value: this.value })
  }

  valueIsSelected(value: number): boolean {
    return this._value == value
  }

  get value(): number {
    return this._value
  }

  set value(v: number) {
    if (v !== this._value) {
      this._value = v
      this.onChangeCallback(v)
    }
  }

  writeValue(value: number) {
    this._value = value
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn
  }

  private onTouchedCallback: () => void = noop

  private onChangeCallback: (_: any) => void = noop
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/pages/admin/online-sessions/number-select.component.ts